import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Frente de la tarjeta = solo la foto que sube el negocio (proporción 1.75:1). */
@Component({
  selector: 'app-card-front',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="card" [class.is-empty]="!url() && !backgroundColor()" [style.background]="url() ? null : backgroundColor()">
      @if (url()) { <img [src]="url()" alt="Frente de la tarjeta" loading="lazy" /> }
      @else if (backgroundColor()) {
        <div class="ph ph--solid" [style.color]="textColor() || '#FFFFFF'"><span>{{ placeholder() }}</span></div>
      } @else {
        <div class="ph">
          <cr-icon name="image" [size]="22" />
          <span>{{ placeholder() }}</span>
        </div>
      }
    </div>
  `,
  styles: [`
    :host{display:block;container-type:inline-size;aspect-ratio:392/224;width:100%}
    .card{width:100%;height:100%;border-radius:calc(100cqw * 20 / 392);overflow:hidden;background:#EFE6D4;
      box-shadow:var(--shadow, var(--cr-card-physical))}
    img{width:100%;height:100%;object-fit:cover;display:block}
    .card.is-empty{background:var(--cr-bg-surface);border:2px dashed var(--cr-border-strong);box-shadow:none}
    .ph{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;color:var(--cr-text-tertiary);
      font:600 clamp(9px, 3.6cqw, 14px)/1.2 var(--cr-font-body);text-align:center;padding:8px}
    .ph--solid{font-size:clamp(10px, 6cqw, 22px);padding:8%;word-break:break-word}
  `],
})
export class CardFrontComponent {
  readonly url = input<string | null | undefined>(null);
  readonly placeholder = input<string>('Tu diseño');
  /** Sin foto pero con tarjeta existente: frente sólido con este color y `placeholder` (nombre de la tarjeta) en `textColor`. */
  readonly backgroundColor = input<string | null | undefined>(null);
  readonly textColor = input<string | null | undefined>(null);
}
